<template v-slot:items="props">
    <div class="page-container">
        <div style="margin-bottom: 30px" v-for="blogArticle in blogs" :key="blogArticle.id">
            <div class="blog-container">
                <BlogArticleCard :blogArticle="blogArticle" ></BlogArticleCard>
            </div>
        </div>
    </div>
</template>

<script>

    import BlogArticleCard from "@/components/BlogArticleCard";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "BlogArticle",
        components: { BlogArticleCard },
        computed: {
            ...mapGetters(['allBlogs']),
            ...mapActions(['fetchBlogList']),
            // display the item from store state.
            blogs () {
                console.log('blogs: ', this.$store.state.blog.blogList);
                return this.$store.state.blog.blogList;
            }

        },
        // Server-side only
        // This will be called by the server renderer automatically
        serverPrefetch () {
            // return the Promise from the action
            // so that the component waits before rendering
            return this.fetchBlogList;
        },

        // Client-side only
        mounted () {
            window.scrollTo(0, 0);
            // If we didn't already do it on the server
            // we fetch the item (will first show the loading text)
            if (!this.blogList) {
                this.fetchBlogList;
            }
        },

        methods: {
            fetchItem () {
                // return the Promise from the action
                return this.$store.dispatch('fetchBlogList')
            }
        }

    }
</script>

<style scoped>

    .fade-enter-active, .fade-leave-active {
        transition: opacity 2.5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .page-container {
        background: linear-gradient(to left, black, #202020);
    }

    .headline {
        font-size: 40px;
        font-weight: bold;
    }

    .blog-container {
        padding: 0!important;
    }

    @media only screen and (max-width: 699px) {
        .headline {
            font-size: 20px;
        }
    }

    @media only screen and (min-width: 700px) and (max-width: 899px){
        .blog-container {
            max-width: 100vw;
            margin: auto
        }

        .headline {
            font-size: 30px;
        }
    }

    @media only screen and (min-width: 900px) and (max-width: 1200px) {
        .blog-container {
            max-width: 800px;
            margin: auto;
        }

        .headline {
            font-size: 35px;
        }
    }

    @media only screen and (orientation: landscape) and (min-width: 1000px) {
        .blog-container {
            margin: auto;
            padding-right: 4vh;
        }
    }

</style>
